"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CookieAgreementsContextProvider = exports.useCookieAgreements = void 0;
var _react = _interopRequireWildcard(require("react"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _router = require("next/router");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var CookieAgreementsContext = /*#__PURE__*/_react["default"].createContext();
var CookieAgreementsContextProvider = function CookieAgreementsContextProvider(_ref) {
  var children = _ref.children,
    analyticsID = _ref.analyticsID,
    gtmID = _ref.gtmID,
    fbID = _ref.fbID;
  var cookieName = global.__appConfig__.agreementsCookieName;
  var cookie = _jsCookie["default"].get(cookieName);
  var _useState = (0, _react.useState)(cookie ? JSON.parse(cookie) : false),
    cookieAgreements = _useState[0],
    setCookieAgreementsValue = _useState[1];
  if (!cookieAgreements) {
    if (cookie) {
      setCookieAgreementsValue(JSON.parse(cookie));
    }
  }
  var setCookieAgreementsState = function setCookieAgreementsState(values) {
    setCookieAgreementsValue(values);
  };
  var setCookieAgreements = function setCookieAgreements(values) {
    _jsCookie["default"].set(cookieName, JSON.stringify(values), {
      expires: 60
    });
    setCookieAgreementsValue(values);
  };
  return __jsx(CookieAgreementsContext.Provider, {
    value: {
      cookieAgreements: cookieAgreements,
      analyticsID: analyticsID,
      gtmID: gtmID,
      fbID: fbID,
      setCookieAgreementsState: setCookieAgreementsState,
      setCookieAgreements: setCookieAgreements
    }
  }, children);
};
exports.CookieAgreementsContextProvider = CookieAgreementsContextProvider;
var useCookieAgreements = function useCookieAgreements() {
  var router = (0, _router.useRouter)();
  var cookie = _jsCookie["default"].get(global.__appConfig__.agreementsCookieName);
  var _useContext = (0, _react.useContext)(CookieAgreementsContext),
    cookieAgreements = _useContext.cookieAgreements,
    setCookieAgreementsState = _useContext.setCookieAgreementsState;
  (0, _react.useEffect)(function () {
    if (cookie && !cookieAgreements) {
      setCookieAgreementsState(JSON.parse(cookie));
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (!cookie) {
      setCookieAgreementsState(false);
    }
  }, [router.asPath]);
  return (0, _react.useContext)(CookieAgreementsContext);
};
exports.useCookieAgreements = useCookieAgreements;